import { useRef, useState, useEffect } from "react";
import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Flip, ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { styled } from '@mui/material/styles';
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { IoArrowBackSharp } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
// import video1 from './Backgroundvideo.mp4';
import { CiMail } from "react-icons/ci";
import { GoPasskeyFill } from "react-icons/go";

/**
 * @fileoverview LoginForm component for user authentication.
 * @module LoginForm
 * @description Handles user login, error handling, password visibility toggle, and role-based redirection.
 */

const LoginForm = () => {
const video1 = "/Backgroundvideo.mp4";
  const [loading, setLoading] = useState(false);  // State to manage loading indicator
  const history = useHistory();// React Router history for navigation
  const subBtn = useRef(null); // Reference to the submit button for keyboard event handling
  const [attemptCount, setAttemptCount] = useState(0);// State to track failed login attempts
  const [showError, setShowError] = useState(false);  // State to control error message display
  const [showPassword, setShowPassword] = useState(false);// State to toggle password visibility
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  }); // State to manage user login data

  // Forgot Password States
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [resetPasswordData, setResetPasswordData] = useState({
    email: '',
    otp: '',
    password: '',
    password2: ''
  });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);

  /**
  * Handles input field changes and updates the state.
  * @param {Event} event - Input change event
  */
  const handleChange = (event) => {
    setLoginData({
      ...loginData,
      [event.target.name]: event.target.value
    });
  };

  /**
   * Handles login error responses and displays appropriate messages.
   * @param {Object} error - Axios error response
   */
 const handleLoginError = (error) => {
  if (error.response?.data) {
    const passwordError =
      error.response.data?.error?.msg?.password?.[0];

    // Password is wrong
    if (passwordError) {
      toast.error(passwordError, {
        position: "top-right",
        transition: Zoom,
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    // Email does not exist
    toast.error(
      "User with this email does not exist. Please check and enter a valid email address.",
      {
        position: "top-right",
        transition: Zoom,
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );
    return;
  }

  // Network/server error
  toast.error("Something went wrong. Please try again.", {
    position: "top-right",
    transition: Zoom,
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

  /**
  * Handles login button click, performs validation, and sends API request.
  */
  const handleClick = async () => {
    if (loginData.email === '' || loginData.password === '') {
      toast.warn("Fields can't be empty!", { position: "top-right", transition: Flip, autoClose: 1500 });
      return;
    }

    try {
      const response = await toast.promise(
        axios.post(`${process.env.REACT_APP_BE_MAIN_URL}/user/login/`, loginData, {
          headers: { Accept: 'application/json' }
        }),
        {
          pending: 'Getting you in..!',
          success: 'Login successful! Redirecting...'
        }
      );

      if (response.status === 200) {
        const { access } = response.data.token;
        const role = response.data.token.role;
        console.log("LOGIN SUCCESS: Role received:", role);
        
        sessionStorage.setItem("userToken", access);
        sessionStorage.setItem("userRole", role);
        sessionStorage.setItem("email", loginData.email);

        toast.success(`Welcome ${role}! Redirecting...`, {
            position: "top-right",
            autoClose: 1500
        });

        setAttemptCount(0);
        setShowError(false);
        setTimeout(() => pushToDashboard(role), 1500);
      }
    } catch (error) {
      handleLoginError(error);
    }
  };

  /**
  * Redirects user to the appropriate dashboard based on role.
  * @param {string} role - User role retrieved from API response
  */
  const pushToDashboard = (role) => {
    console.log("Pushing to dashboard for role:", role);
    if (role === "Admin" || role === "Useradmin") {
      history.push('/admin/dashboard');
    } else if (role === "SystemAdmin" || role === "System Admin") {
      history.push('/system-admin');
    } else if (role === "Annotator" || role === "Annoter") {
      history.push('/task');
    } else {
      history.push('/OrgChart');
    }
  };

  /**
    * Adds an event listener to handle form submission on 'Enter' key press.
    */
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.keyCode === 13) {
        console.log("Enter");
        event.preventDefault();
        subBtn.current.click();
      }
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });

  // Clears session storage on component mount
  useEffect(() => {
    sessionStorage.clear();
  }, []);

  //  const handleTaskClick = () => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     history.push('/task');
  //   }, 1000); 
  // };

  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    fontFamily: 'Montserrat'
  }));

  /**
   * Toggles password visibility state.
   */
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  /**
   * Opens the forgot password modal
   */
  const handleForgotPasswordClick = () => {
    setShowForgotPasswordModal(true);
    setResetPasswordData({
      email: '',
      otp: '',
      password: '',
      password2: ''
    });
    setOtpSent(false);
  };

  /**
   * Closes the forgot password modal
   */
  const closeForgotPasswordModal = () => {
    setShowForgotPasswordModal(false);
    setResetPasswordData({
      email: '',
      otp: '',
      password: '',
      password2: ''
    });
    setOtpSent(false);
  };

  /**
   * Sends OTP to user's email
   */
  const handleSendOTP = async () => {
    const { email } = resetPasswordData;

    if (!email) {
      toast.warn("Please enter your email address", {
        position: "top-right",
        transition: Flip,
        autoClose: 2000
      });
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address", {
        position: "top-right",
        transition: Zoom,
        autoClose: 2000
      });
      return;
    }

    setOtpLoading(true);

    try {
      const response = await toast.promise(
        axios.post(`${process.env.REACT_APP_BE_MAIN_URL}/user/send-otp/`, {
          email: email
        }, {
          headers: { Accept: 'application/json' }
        }),
        {
          pending: 'Sending OTP to your email...',
          success: 'OTP sent successfully!',
          error: 'Failed to send OTP'
        }
      );

      if (response.status === 200 || response.status === 201) {
        setOtpSent(true);
        toast.info('Please check your email for the OTP code', {
          position: "top-right",
          autoClose: 3000
        });
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data.error || error.response.data;
        let errorMessage = '';
        
        if (typeof errorData === 'object') {
          Object.keys(errorData).forEach(key => {
            if (Array.isArray(errorData[key])) {
              errorMessage += errorData[key].join(' ') + ' ';
            } else {
              errorMessage += errorData[key] + ' ';
            }
          });
        } else if (typeof errorData === 'string') {
          errorMessage = errorData;
        }
        
        toast.error(errorMessage.trim() || 'Error sending OTP', {
          position: "top-right",
          transition: Zoom,
          autoClose: 3000
        });
      } else {
        toast.error('Network error. Please try again.', {
          position: "top-right",
          transition: Zoom,
          autoClose: 3000
        });
      }
    } finally {
      setOtpLoading(false);
    }
  };

  /**
   * Handles password reset with OTP verification
   */
  const handleResetPassword = async () => {
    const { email, otp, password, password2 } = resetPasswordData;

    if (!email || !otp || !password || !password2) {
      toast.warn("All fields are required", {
        position: "top-right",
        transition: Flip,
        autoClose: 2000
      });
      return;
    }

    if (password !== password2) {
      toast.error("Passwords do not match", {
        position: "top-right",
        transition: Zoom,
        autoClose: 2000
      });
      return;
    }

    if (password.length < 8) {
      toast.warn("Password must be at least 8 characters long", {
        position: "top-right",
        transition: Flip,
        autoClose: 2000
      });
      return;
    }

    try {
      const response = await toast.promise(
        axios.post(`${process.env.REACT_APP_BE_MAIN_URL}/user/forgot-password/`, {
          email: email,
          otp: otp,
          password: password,
          password2: password2
        }, {
          headers: { Accept: 'application/json' }
        }),
        {
          pending: 'Verifying OTP and resetting password...',
          success: 'Password reset successful!',
          error: 'Failed to reset password'
        }
      );

      if (response.status === 200 || response.status === 201) {
        setTimeout(() => {
          closeForgotPasswordModal();
          toast.success('You can now login with your new password', {
            position: "top-right",
            autoClose: 2000
          });
        }, 1500);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        // Extract error messages from backend response
        const errorData = error.response.data.error || error.response.data;
        let errorMessage = '';
        
        // Handle different error formats
        if (typeof errorData === 'object') {
          // Collect all error messages from the error object
          Object.keys(errorData).forEach(key => {
            if (Array.isArray(errorData[key])) {
              errorMessage += errorData[key].join(' ') + ' ';
            } else {
              errorMessage += errorData[key] + ' ';
            }
          });
        } else if (typeof errorData === 'string') {
          errorMessage = errorData;
        }
        
        toast.error(errorMessage.trim() || 'Error resetting password', {
          position: "top-right",
          transition: Zoom,
          autoClose: 3000
        });
      } else {
        toast.error('Network error. Please try again.', {
          position: "top-right",
          transition: Zoom,
          autoClose: 3000
        });
      }
    }
  };

  return (
    <div className="flex flex-col justify-center  items-center flex-1 h-screen px-6 py-12 lg:px-8  relative ">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover -z-10"
      >
        {/* <source src={video1} type="video/mp4" /> */}
          <source src="https://demo-s3sourceoptima.s3.us-east-1.amazonaws.com/Backgroundvideo.mp4" type="video/mp4" />
      
      </video>
      <div className="absolute top-6 left-6 text-white text-3xl cursor-pointer hover:text-orange-300 transition duration-300">
        <Link to="/"><IoArrowBackSharp size={40} /></Link>
      </div>

      <div className="  w-[520px]   transition-all duration-300 ease-in-out  ">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm ">
          <h2 className="mt-10 text-3xl font-bold leading-9 tracking-tight text-center text-white">Login your account!</h2>
        </div>
        <hr className="mt-4 mx-9 border-gray-400 bg-gray-400" />
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm flex flex-col gap-2" style={{ zIndex: "10", }}>
          {/* Email Input */}
          <div>
            <label htmlFor="email" className=" flex gap-2 text-[20px] font-medium leading-6 text-white" >
              <CiMail fontSize={24} />  Email
            </label>
            <div className=" relative mt-2">
              <input
                id="email"
                name="email"
                type="email"
                required
                className="block w-full h-[44px] bg-gray-700/20 rounded-md border border-gray-400 p-2 text-white shadow-sm  ring-gray-500/50 placeholder:text-gray-300 sm:text-xl sm:leading-6 outline-none focus:border-gray-300 focus:ring-gray-300"
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>
          <div>
            {/* Password Input */}
            <div className="flex items-center justify-between">
              <label htmlFor="password" className="flex gap-2 text-[20px] font-medium leading-6 text-white">
                <GoPasskeyFill fontSize={24} /> Password
              </label>
            </div>
            <div className="relative mt-2">
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                required
                className="block w-full h-[40px] bg-gray-700/20 rounded-md border border-gray-400 p-2 text-white shadow-sm  ring-gray-500/50 placeholder:text-gray-300 sm:text-xl sm:leading-6 outline-none focus:border-gray-300 focus:ring-gray-300"
                onChange={(event) => handleChange(event)}
              />
              <div
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer text-gray-500 hover:text-gray-700"
              >
                {showPassword ? <FaEye color="white" size={20} /> : <FaEyeSlash color="white" size={20} />}
              </div>
            </div>
            <Link to="#" onClick={(e) => { e.preventDefault(); handleForgotPasswordClick(); }} className="text-xl text-white hover:text-orange-300 float-right mt-1 transition duration-300">Forgot Password?</Link>
          </div>
          <div>

            < Link to="/task" className="font-medium text-xl text-white hover:text-orange-300 transition duration-300"></Link>
            {/* Submit Button */}
            <button
              type="submit"
              className="mt-2 h-[40px] w-full rounded-md text-xl  transition delay-150 duration-300   bg-[#FECF8B] text-black font-semibold shadow-md hover:bg-white hover:text-orange-400 hover:border border-orange-400"
              onClick={() => handleClick()}
              ref={subBtn}
            >
              Submit
            </button>
            {/* Lockout Error Message */}
            {showError && (
              <div className="mt-4 text-white text-center text-lg font-semibold ">
                Your account is locked due to multiple failed login attempts. Please reset your password!
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Forgot Password Modal */}
      {showForgotPasswordModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-gray-800 rounded-lg shadow-xl p-8 w-full max-w-md relative">
            {/* Close Button */}
            <button
              onClick={closeForgotPasswordModal}
              className="absolute top-4 right-4 text-gray-400 hover:text-white transition"
            >
              <IoClose size={28} />
            </button>

            <h2 className="text-2xl font-bold text-white mb-6">
              Reset Password
            </h2>

            <div className="space-y-4">
              <div>
                <label htmlFor="forgot-email" className="flex gap-2 text-lg font-medium text-white mb-2">
                  <CiMail fontSize={24} /> Email Address
                </label>
                <div className="flex gap-2">
                  <input
                    id="forgot-email"
                    name="forgot-email"
                    type="email"
                    value={resetPasswordData.email}
                    onChange={(e) => setResetPasswordData({ ...resetPasswordData, email: e.target.value })}
                    disabled={otpSent}
                    className="block w-full h-[44px] bg-gray-700/50 rounded-md border border-gray-400 p-3 text-white shadow-sm placeholder:text-gray-400 sm:text-lg outline-none focus:border-gray-300 focus:ring-1 focus:ring-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                    placeholder="Enter your email"
                  />
                  {!otpSent && (
                    <button
                      onClick={handleSendOTP}
                      disabled={otpLoading}
                      className="px-4 h-[44px] rounded-md text-sm font-semibold bg-[#FECF8B] text-black shadow-md hover:bg-white hover:text-orange-400 transition duration-300 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {otpLoading ? 'Sending...' : 'Send OTP'}
                    </button>
                  )}
                </div>
                {otpSent && (
                  <p className="text-green-400 text-sm mt-1">
                    OTP sent! Check your email.
                  </p>
                )}
              </div>

              {otpSent && (
                <>
                  <div>
                    <label htmlFor="otp" className="flex gap-2 text-lg font-medium text-white mb-2">
                      <GoPasskeyFill fontSize={24} /> OTP Code
                    </label>
                    <input
                      id="otp"
                      name="otp"
                      type="text"
                      value={resetPasswordData.otp}
                      onChange={(e) => setResetPasswordData({ ...resetPasswordData, otp: e.target.value })}
                      className="block w-full h-[44px] bg-gray-700/50 rounded-md border border-gray-400 p-3 text-white shadow-sm placeholder:text-gray-400 sm:text-lg outline-none focus:border-gray-300 focus:ring-1 focus:ring-gray-300"
                      placeholder="Enter OTP from email"
                      maxLength="6"
                    />
                  </div>

                  <div>
                    <label htmlFor="new-password" className="flex gap-2 text-lg font-medium text-white mb-2">
                      <GoPasskeyFill fontSize={24} /> New Password
                    </label>
                    <div className="relative">
                      <input
                        id="new-password"
                        name="new-password"
                        type={showNewPassword ? "text" : "password"}
                        value={resetPasswordData.password}
                        onChange={(e) => setResetPasswordData({ ...resetPasswordData, password: e.target.value })}
                        className="block w-full h-[44px] bg-gray-700/50 rounded-md border border-gray-400 p-3 text-white shadow-sm placeholder:text-gray-400 sm:text-lg outline-none focus:border-gray-300 focus:ring-1 focus:ring-gray-300"
                        placeholder="Enter new password"
                      />
                      <div
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                      >
                        {showNewPassword ? <FaEye color="white" size={20} /> : <FaEyeSlash color="white" size={20} />}
                      </div>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="confirm-password" className="flex gap-2 text-lg font-medium text-white mb-2">
                      <GoPasskeyFill fontSize={24} /> Confirm Password
                    </label>
                    <div className="relative">
                      <input
                        id="confirm-password"
                        name="confirm-password"
                        type={showConfirmPassword ? "text" : "password"}
                        value={resetPasswordData.password2}
                        onChange={(e) => setResetPasswordData({ ...resetPasswordData, password2: e.target.value })}
                        className="block w-full h-[44px] bg-gray-700/50 rounded-md border border-gray-400 p-3 text-white shadow-sm placeholder:text-gray-400 sm:text-lg outline-none focus:border-gray-300 focus:ring-1 focus:ring-gray-300"
                        placeholder="Confirm new password"
                      />
                      <div
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                      >
                        {showConfirmPassword ? <FaEye color="white" size={20} /> : <FaEyeSlash color="white" size={20} />}
                      </div>
                    </div>
                  </div>

                  <button
                    onClick={handleResetPassword}
                    className="w-full h-[44px] rounded-md text-lg font-semibold bg-[#FECF8B] text-black shadow-md hover:bg-white hover:text-orange-400 hover:border border-orange-400 transition duration-300"
                  >
                    Reset Password
                  </button>
                </>
              )}

              {otpSent && (
                <div className="text-center">
                  <button
                    onClick={() => {
                      setOtpSent(false);
                      setResetPasswordData({ ...resetPasswordData, otp: '', password: '', password2: '' });
                    }}
                    className="text-sm text-gray-400 hover:text-white transition"
                  >
                    Change email? Click here
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};
export default LoginForm;
